<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { configLabelListApi } from '@/api'
import { mapMutations } from 'vuex'
export default {
  name: 'App',
  created () {
    this.getAllInfo()
  },
  methods: {
    ...mapMutations(['setProjectInfo']),
    getAllInfo () {
      configLabelListApi().then(res => {
        const data = res.data
        this.setProjectInfo(data)
        // 动态修改页面标题
        // if (data.projectName) {
        //   document.title = data.projectName
        // }
        // // 动态修改 favicon
        // if (data.iconUrl) {
        //   let link = document.querySelector('link[rel="icon"]')
        //   if (!link) {
        //     link = document.createElement('link')
        //     link.rel = 'icon'
        //     document.head.appendChild(link)
        //   }
        //   link.href = data.iconUrl
        // }
      })
    }
  }
}
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
::-webkit-scrollbar {
  display: none;
}
// @import './assets/styles/cover.less';
</style>
